import * as urlUtil from 'js/utils/url.util';

export const getDynamicImageUrl = (dynamicImageUrl, timestamp) => {
    try {
        const url = new window.URL(dynamicImageUrl);

        return urlUtil.addParamsToUrl({ t: timestamp }, url.href);
    } catch {
        return '';
    }
};
